import { DetectionSource } from "../Common/DetectionSource";
import { DateTime } from "luxon";

// TODO: nullability is wrong
export class GeoRehandleDTO {
  geoRehandleId: number;
  operationId: number;
  officerId?: number;
  loads?: number;
  movementFromId?: number;
  movementToId?: number;
  bucketTypeId?: number;
  spotterId?: number;
  plantId?: number;
  hour?: number;
  materialTypeClassId?: number;
  tonnes?: number;
  density?: number;
  wetTonnes?: number;
  adjTonnesHauled?: number;
  lastEdited?: DateTime;

  /** Note: provenance. Both the Rehandle and Crushing screens read this DTO - they are the same
   *  tblGeoRehandle rows split on whether the destination is a crusher - so a chip added for one must be
   *  added for the other, or an inferred stockpile-to-crusher rehandle shows unmarked. */
  detectionSource?: DetectionSource;
  isVerified?: boolean;
  confidence?: number;
  /** Note: the truck a digger or loader filled, set only where the screen collects the truck itself. */
  truckPlantId?: number;
  /** Note: when the movement happened, unlike lastEdited which is when the row was touched. A DateTime once
   *  parseDateTimes has read it from the API or the offline cache, the ISO string a time picker produced
   *  until then. */
  movementTimeUtc?: DateTime | string;

  rowVersion?: string;

  constructor(data: {
    geoRehandleId: number;
    operationId: number;
    officerId?: number;
    loads?: number;
    movementFromId?: number;
    movementToId?: number;
    bucketTypeId?: number;
    spotterId?: number;
    plantId?: number;
    hour?: number;
    materialTypeClassId?: number;
    tonnes?: number;
    density?: number;
    wetTonnes?: number;
    adjTonnesHauled?: number;
    lastEdited?: DateTime;
    detectionSource?: DetectionSource;
    isVerified?: boolean;
    confidence?: number;
    truckPlantId?: number;
    movementTimeUtc?: DateTime | string;
    rowVersion?: string;
  }) {
    this.geoRehandleId = data.geoRehandleId;
    this.operationId = data.operationId;
    this.officerId = data.officerId;
    this.loads = data.loads;
    this.movementFromId = data.movementFromId;
    this.movementToId = data.movementToId;
    this.bucketTypeId = data.bucketTypeId;
    this.spotterId = data.spotterId;
    this.plantId = data.plantId;
    this.hour = data.hour;
    this.materialTypeClassId = data.materialTypeClassId;
    this.tonnes = data.tonnes;
    this.density = data.density;
    this.wetTonnes = data.wetTonnes;
    this.adjTonnesHauled = data.adjTonnesHauled;
    this.lastEdited = data.lastEdited;
    this.detectionSource = data.detectionSource;
    this.isVerified = data.isVerified;
    this.confidence = data.confidence;
    this.truckPlantId = data.truckPlantId;
    this.movementTimeUtc = data.movementTimeUtc;
    this.rowVersion = data.rowVersion;
  }
}
